import {
    Grid, MenuItem, Box, Paper,
    Button, Stack, TextField, Modal, Typography,
    Divider
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Form from "../common/Form";
import Controls from "../controls/Controls";
import useForm from "../common/useForm";
import { useEffect, useState } from "react";
import { addNewClient, addNewClientApp, clientAdded, getClientAddedStatus } from "../../store/clients";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close"

const initialFormValues = {
    //issueStatus: "",
    id: 0,
    appName: "",
    appUrl: "",
    addedBy: 1,
};

const AddApp = (props) => {

    const { setNotify, setOpenPopup, selectedApp, handleAddApp } = props;
    const [validateOnChange, setValidateOnChange] = useState(true);
    const [appObj, setAppObj] = useState({});

    const clientAddedStatusSelector = useSelector(getClientAddedStatus)

    const dispatch = useDispatch();
    const validate = (fieldValues = formValues) => {
        let temp = { ...errors };
        // if ("issueStatus" in fieldValues)
        //   temp.issueStatus = fieldValues.issueStatus
        //     ? ""
        //     : "This field is required.";
        if ("reviewNotes" in fieldValues)
            temp.reviewNotes = fieldValues.reviewNotes
                ? ""
                : "This field is required.";

        setErrors({ ...temp });
        if (fieldValues === formValues)
            return Object.values(temp).every((x) => x === "");
    };

    useEffect(() => {
        if (selectedApp) setAppObj(selectedApp);
        else setAppObj(initialFormValues);
    }, [selectedApp])

    const { formValues, errors, setErrors, handleOnChange, resetForm } = useForm(
        appObj,
        validateOnChange,
        validate,
        setValidateOnChange
    );

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            dispatch(addNewClientApp(formValues));
        }
    };

    useEffect(() => {
        if (clientAddedStatusSelector) {
            setNotify({
                isOpen: true,
                message: `${formValues?.id === 0 ? "Added Successfully" : "Updated Successfully"}`,
                type: "success",
            });
            handleAddApp("save");
            resetForm();
        }

        return () => {
            dispatch(clientAdded(false))
        }
    }, [clientAddedStatusSelector])

    return <>
        <Form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Controls.Input
                        rows={3}
                        name="appName"
                        label="Name"
                        onChange={handleOnChange}
                        value={formValues?.appName}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Controls.Input
                        rows={3}
                        name="appUrl"
                        label="Application URL"
                        onChange={handleOnChange}
                        value={formValues?.appUrl}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider sx={{ ml: -3, mr: -3, mb: 2 }} />
                    <Stack
                        spacing={2}
                        direction="row"
                        justifyContent="end"
                        alignItems="center"
                    >
                        <Controls.Button
                            text="Close"
                            color="error"
                            size="small"
                            variant="outlined"
                            onClick={() => handleAddApp(null)}
                            startIcon={<CloseIcon />}
                            sx={{
                                width: "80px",
                                '&:hover': {
                                    backgroundColor: 'red',
                                    color: 'white',
                                    border: 'none',
                                }
                            }}
                        ></Controls.Button>
                        <Controls.Button
                            text="Save"
                            type="submit"
                            size="small"
                            variant="outlined"
                            startIcon={<SaveIcon />}
                            sx={{
                                width: "80px",
                                color: 'black',
                                border: "1px solid black",
                                '&:hover': {
                                    backgroundColor: 'black',
                                    color: 'white',

                                }
                            }}
                        ></Controls.Button>
                    </Stack>
                </Grid>
            </Grid>
        </Form>
    </>
}

export default AddApp;